"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FileCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const useDevice_1 = require("../../hooks/useDevice");
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
const spacing_1 = require("../../common/spacing");
const borders_1 = require("../../common/borders");
const file_types_pdf_svg_1 = require("../../assets/icons/file-types-pdf.svg");
const file_types_link_svg_1 = require("../../assets/icons/file-types-link.svg");
function FileCard({ fileName, sourcePath, webUrl }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const displayPath = (0, react_1.useMemo)(() => (webUrl || sourcePath), [webUrl, sourcePath]);
    const handlePress = (0, react_1.useCallback)(() => {
        react_native_1.Linking.openURL(displayPath);
    }, [displayPath]);
    const FileIcon = webUrl ? file_types_link_svg_1.ReactComponent : file_types_pdf_svg_1.ReactComponent;
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: handlePress, onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), children: (0, jsx_runtime_1.jsxs)(react_native_linear_gradient_1.default, { colors: isHovered
                ? ['rgba(83, 83, 89, 0.42)', 'rgba(83, 83, 89, 0.23)']
                : ['rgba(83, 83, 89, 0.32)', 'rgba(83, 83, 89, 0.13)'], start: { x: 0, y: 0 }, end: { x: 1, y: 0 }, locations: [0.15, 0.8375], style: [
                styles.container,
                isMobileScreen && styles.containerMobile,
                isHovered && styles.containerHovered
            ], children: [(0, jsx_runtime_1.jsx)(FileIcon, { viewBox: `0 0 ${isMobileScreen ? 40 : 36} ${isMobileScreen ? 38.5 : 44}` }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sourceContainer, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [styles.text, isMobileScreen && styles.textMobile, styles.description], children: "Summary source:" }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [styles.text, isMobileScreen && styles.textMobile, styles.sourceName], children: fileName })] }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowUpRightFromSquare, color: 'white', size: 16 })] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        gap: spacing_1.Spacing.SPACING_XL,
        flexDirection: 'row',
        alignItems: 'center',
        padding: spacing_1.Spacing.SPACING_XL,
        paddingLeft: spacing_1.Spacing.SPACING_MD,
        borderRadius: borders_1.Borders.RADIUS_XL,
        transition: 'all 0.3s ease',
    },
    containerMobile: {
        padding: spacing_1.Spacing.SPACING_MD,
        paddingRight: spacing_1.Spacing.SPACING_XL,
    },
    containerHovered: {
        transform: [{ scale: 1.02 }],
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    sourceContainer: {
        flex: 1,
    },
    text: {
        lineHeight: 18,
    },
    textMobile: {
        fontSize: 12,
    },
    description: {
        color: colors_1.Colors.DARK_100,
    },
    sourceName: {
        color: 'white',
        fontWeight: '500',
    },
});
